module.exports = __webpack_public_path__ + "img/dispatch_error.fc7417ec.svg";